import scrollLoad from '@xunlei/scroll-load';

var load = {
  inserted: function inserted(el, _ref) {
    var value = _ref.value;

    if (typeof value === 'function') {
      scrollLoad(value, {
        target: el
      });
    } else {
      scrollLoad(value.handler, {
        target: el,
        root: el.parentElement,
        distance: value.distance
      });
    }
  },
  install: function install(Vue) {
    Vue.directive('load', load);
  }
};

export default load;
